function sortAtoZ(data, key) {
  if (!Array.isArray(data)) return [];

  // If key is provided → sort objects by that key
  if (key) {
    return data.sort((a, b) => {
      const valA = (a[key] || "").toString().trim();
      const valB = (b[key] || "").toString().trim();

      return valA.localeCompare(valB, undefined, { sensitivity: "base" });
    });
  }

  // If no key → assume array of strings
  return data
    .map(v => (v || "").toString().trim())
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
}
export { sortAtoZ} ;
